import * as React from 'react';

export interface IColorSquareProps {
  hex: string;
}

export class ColorSquare extends React.Component<IColorSquareProps> {
  public render() {
    return (
      <div
        style={{
          width: '30px',
          height: '30px',
          marginRight: '5px',
          borderStyle: 'solid',
          borderWidth: '3px',
          display: 'inline-block',
          // position: 'relative',
          backgroundColor: this.props.hex,
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Others/ColorSquare/ColorSquare.tsx